module.exports = __webpack_public_path__ + "img/lars_old.5300043c.jpeg";